import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CareersHero from './components/CareersHero';
import WhyWorkHere from './components/WhyWorkHere';
import Benefits from './components/Benefits';
import OpenPositions from './components/OpenPositions';

export default function CareersPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';

  useEffect(() => {
    document.title = 'Carrières TrackVerse — Rejoignez Notre Équipe Logistique Mondiale | Ajaccio';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Rejoignez TrackVerse et participez à la révolution logistique mondiale. Explorez nos opportunités de carrière dans 50+ pays : technologie, opérations, ventes. Avantages compétitifs et évolution garantis.');
    setMeta('keywords', 'carrières TrackVerse, emplois logistique, recrutement expédition, jobs supply chain, offres emploi Ajaccio');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/careers`;

    setMeta('og:title', 'Carrières TrackVerse — Rejoignez Notre Équipe Logistique', true);
    setMeta('og:description', 'Opportunités de carrière dans 50+ pays. Technologie, opérations, ventes. Avantages compétitifs.', true);
    setMeta('og:url', `${siteUrl}/careers`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'Carrières TrackVerse — Rejoignez Notre Équipe');
    setMeta('twitter:description', 'Opportunités de carrière dans 50+ pays en logistique internationale.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const careersSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Carrières TrackVerse",
      "url": `${siteUrl}/careers`,
      "description": "Opportunités de carrière chez TrackVerse dans la logistique internationale",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "Carrières", "item": `${siteUrl}/careers` }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Offres d'emploi TrackVerse",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "item": { "@type": "JobPosting", "title": "Coordinateur Logistique Senior", "description": "Gérer les expéditions internationales et coordonner avec les partenaires mondiaux", "hiringOrganization": { "@type": "Organization", "name": "TrackVerse", "sameAs": `${siteUrl}` }, "jobLocation": { "@type": "Place", "address": { "@type": "PostalAddress", "addressLocality": "Ajaccio", "addressCountry": "FR" } }, "employmentType": "FULL_TIME" } },
          { "@type": "ListItem", "position": 2, "item": { "@type": "JobPosting", "title": "Ingénieur Logiciel", "description": "Développer et maintenir notre plateforme de suivi et logiciels logistiques", "hiringOrganization": { "@type": "Organization", "name": "TrackVerse", "sameAs": `${siteUrl}` }, "jobLocation": { "@type": "Place", "address": { "@type": "PostalAddress", "addressLocality": "Remote", "addressCountry": "Worldwide" } }, "employmentType": "FULL_TIME" } }
        ]
      }
    };

    let script = document.querySelector('script[data-schema="careers"]');
    if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', 'careers'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(careersSchema);

    return () => { const s = document.querySelector('script[data-schema="careers"]'); if (s) s.remove(); };
  }, [siteUrl]);

  return (
    <>
      <Navbar />
      <CareersHero />
      <WhyWorkHere />
      <Benefits />
      <OpenPositions />
      <Footer />
    </>
  );
}
